const LANDMARK_TYPES = {
    EPIPHANY: "EPIPHANY",
    PROJECTS: "PROJECTS",
    STUDY: "STUDY",
    CAREER: "CAREER",
    CERTIFICATION: "CERTIFICATION"
}

const TIMELINE = {
    LANDMARK_TYPES,
    LANDMARKS: [
        {
            event: "Built my first gaming PC",
            description: `Built my first ever gaming specific PC to play World of Warcraft`,
            type: LANDMARK_TYPES.EPIPHANY,
            date: "2005"
        },
        {
            event: "Learned how to write Batch and VBS Scripts (wmic, cscript, wscript)",
            description: `Studied, learned and practiced writing VBS scripts to automate various menial desktop tasks`,
            type: LANDMARK_TYPES.STUDY,
            date: "2007"
        },
        {
            event: "Learned how to program in Java",
            description: `I read an O'reilly Headfirst book, studied and learned how to write programs in Java, Java Swing`,
            type: LANDMARK_TYPES.STUDY,
            date: "2010"
        },
        {
            event: "Developed a local Minecraft(beta) mod",
            description: `Using newly learned Java skills I created a minecraft mod for me and my friends to play`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "2010"
        },
        {
            event: "Started hosting Minecraft beta servers",
            description: `I started hosting gaming servers, mainly for Minecraft for friends`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "2010"
        },
        {
            event: "Obtained CompTIA A+ Certification",
            description: `Studied and achieved the CompTIA A+ certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2011"
        },
        {
            event: "Obtained CompTIA Network+ Certification",
            description: `Studied and achieved the CompTIA Network+ certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2011"
        },
        {
            event: "Started at ComputerLand, Morgan Hill Unified School District",
            description: `Started at ComputerLand, Morgan Hill Unified School District as an IT Support Specialist`,
            type: LANDMARK_TYPES.CAREER,
            date: "2012"
        },
        {
            event: "Implemented and managed more enterprise-level infrastructure within my home",
            description: `I bought a Lenovo Server, set up storage as RAID(10) with WD Red HDDs, created and managed several windows servers (DHCP, DNS, SMB + Print and more) with VMWare ESXi`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "2012"
        },
        {
            event: "Obtained CompTIA Security+ Certification",
            description: `Studied and achieved the CompTIA Security+ certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2013"
        },
        {
            event: "Started Learning Powershell Scripting",
            description: `Started learning powershell scripting for better automation and compatibility in work environment`,
            type: LANDMARK_TYPES.STUDY,
            date: "2013"
        },
        {
            event: "Obtained Cisco CCNA R&S Certification",
            description: `Studied and achieved the Cisco Routing and Switching certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2013"
        },
        {
            event: "Started doing IT Consulting Work for Various Companies",
            description: `Did consulting work for various companies, improving my skills and broadening my horizons. I built several offices out completely solo including configuring VoIP systems (FreePBX), Windows Servers (of all sorts), imaging (PXE/MDT/WDS), networking, and several other custom scripts and integrations that I wrote.`,
            type: LANDMARK_TYPES.CAREER,
            date: "2014"
        },
        {
            event: "Learned Full Stack Web Development",
            description: `Studied, practiced and learned Full Stack Web development with Mongo, Express and Node.js`,
            type: LANDMARK_TYPES.STUDY,
            date: "2016"
        },
        {
            event: "Signed on to The Pill Club",
            description: `Started my first day at The Pill Club as a Systems Administrator`,
            type: LANDMARK_TYPES.CAREER,
            date: "2017"
        },
        {
            event: "Wrote a Discord bot and Guild Wars 2 Info Bot (Kuma DSharp Bot)",
            description: `I wrote a discord bot that relays voice channel from Teamspeak server to my discord server utilizing a circle buffer. I also wrote in utility functions for an MMO I used to play called Guild Wars 2.`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "2017"
        },
        {
            event: "Learned React-Native",
            description: `Studied, practiced and learned how to use React-Native to write mobile applications`,
            type: LANDMARK_TYPES.STUDY,
            date: "2017"
        },
        {
            event: "Learned Electron",
            description: `Studied, practiced and learned how to use Electron to write Desktop applications`,
            type: LANDMARK_TYPES.STUDY,
            date: "2017"
        },
        {
            event: "Learned Redux",
            description: `Studied, practiced and learned React state management with Redux`,
            type: LANDMARK_TYPES.STUDY,
            date: "2017"
        },
        {
            event: "Started writing full stack applications, CLI tools and integrations professionally",
            description: `I wrote several full stack applications for web, an electron app for Win10 and macOs for usage by employees at Pill Club`,
            type: LANDMARK_TYPES.CAREER,
            date: "2017"
        },
        {
            event: "Created CircleCI Slack integration for Cypress End-to-End tests in CICD Pipeline",
            description: `I wrote a Slack integration for our CircleCI pipelines which acted as a control for canary deploys and build approvals.`,
            type: LANDMARK_TYPES.CAREER,
            date: "2017"
        },
        {
            event: "Learned Docker",
            description: `Studied and practiced building and using containers with Docker`,
            type: LANDMARK_TYPES.STUDY,
            date: "2017"
        },
        {
            event: "Started designing and implementing DevOps projects",
            description: `Started on projects with common AWS services, building CI/CD pipelines, E2E tests with Cypress, custom build integrations with Slack at Pill Club`,
            type: LANDMARK_TYPES.CAREER,
            date: "2017"
        },
        {
            event: "Promoted to Systems Engineer at Pill Club",
            description: `I was promoted to Systems Engineer at Pill Club`,
            type: LANDMARK_TYPES.CAREER,
            date: "2018"
        },
        {
            event: "Earned AWS Solutions Architect Associate Certification",
            description: `Studied, practiced and obtained the AWS:SAA certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2019"
        },
        {
            event: "Started Development on Hackerbolic",
            description: `Started the Hackerbolic project`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "March 2019"
        },
        {
            event: "Completed Udacity Full Stack Engineer Path",
            description: `Completed capstone and courses for Udacity Full Stack Engineer with Python/Flask`,
            type: LANDMARK_TYPES.STUDY,
            date: "2019"
        },
        {
            event: "Started at Rackspace Technologies",
            description: `Start of a new journey at Rackspace Technologies as a Cloud Engineer`,
            type: LANDMARK_TYPES.CAREER,
            date: "2020"
        },
        {
            event: "Promoted to Cloud Solutions Architect at Rackspace Technologies",
            description: `After a year of hard work and proving myself I was promoted to be a Cloud Solutions Architect at Rackspace`,
            type: LANDMARK_TYPES.CAREER,
            date: "2021"
        },
        {
            event: "Earned AWS Solutions Architect Professional Certification",
            description: `Studied, practiced and obtained the AWS:SAP certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2022"
        },
        {
            event: "Earned AWS Advanced Networking - Specialty Certification",
            description: `Studied, practiced and obtained the AWS:Advanced Networking certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2022"
        },
        {
            event: "Earned AWS DevOps Engineer Professional Certification",
            description: `Studied, practiced and obtained the AWS:DevOps Engineer Professional certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2022"
        },
        {
            event: "Earned Hashicorp Terraform Associate Certification",
            description: `Studied, practiced and earned Hashicorp Terraform Associate certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2023"
        },
        {
            event: "Earned Hashicorp Vault Associate Certification",
            description: `Studied, practiced and earned Hashicorp Vault Associate certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "2023"
        },
        {
            event: "Started Development on Hotstrings",
            description: `Started the Hotstrings project`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "March 2024"
        },
        {
            event: "Learned how to create Electronics",
            description: `Took courses, read books and developed skills on how to engineer electronics using MCUs`,
            type: LANDMARK_TYPES.STUDY,
            date: "June 2024"
        },
        {
            event: "Learned Constraint Based Modeling with Fusion360",
            description: `Learned to model for 3D printing using Fusion360`,
            type: LANDMARK_TYPES.STUDY,
            date: "June 2024"
        },
        {
            event: "Learned 3D Printing and Slicing with UltiMaker Cura",
            description: `Learned to slice 3D models for printing with UltiMaker Cura`,
            type: LANDMARK_TYPES.STUDY,
            date: "June 2024"
        },
        {
            event: "Created Washing Machine Notifier",
            description: `Created Washing Machine Notifier as a fun electronics + 3D printing/modeling project`,
            type: LANDMARK_TYPES.PROJECTS,
            date: "June 2024"
        },
        {
            event: "Obtained Certified Kubernetes Application Developer",
            description: `Studied and obtained CKAD certification`,
            type: LANDMARK_TYPES.CERTIFICATION,
            date: "November 2024"
        },
        {
            event: "Created WhoIAm, My Portfolio",
            description: `Started writing my portfolio "WhoIAm" using React, Terraform, AWS S3, Cloudfront`,
            type: LANDMARK_TYPES.CAREER,
            date: "2024"
        }
    ] 
}



export default TIMELINE;